import { booleanAttribute, computed, Directive, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { resolveTypographyClass } from './color';

@Directive({
    selector: '[qpxColHeader]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxTableColumnHeader {
    public readonly context = input<
        ContextFamily | undefined,
        ContextFamily | '' | undefined
    >(undefined, {
        alias: 'qpxColHeader',
        transform: (value) => value || undefined,
    });

    public readonly tone = input<ContextTone>('default');
    public readonly decorative = input(false, { transform: booleanAttribute });

    protected readonly className = computed(() => {
        return [
            'text-table-column-header',
            resolveTypographyClass(
                this.context(),
                this.tone(),
                this.decorative()
            ),
        ].join(' ');
    });
}
